import type { ArcanaReadingQueueItemDto } from '@lunary/api-client'
import { READING_STATUS, previewText } from '@lunary/app-core/reading-chat-model'
import { NO_NAME, userTitle } from '../users/identity'
import { waitingLabel } from './labels'
import styles from './readings.module.css'

type Props = {
  items: ArcanaReadingQueueItemDto[]
  selectedId: string | null
  now: number
  onSelect: (id: string) => void
}

const WAITING = new Set(['pending', 'clarifying'])

export function QueueList({ items, selectedId, now, onSelect }: Props) {
  return (
    <nav className={styles.queue} aria-label="Разборы">
      {items.map((item) => {
        const name = item.person ? userTitle(item.person).title : NO_NAME
        const waiting = WAITING.has(item.status)
        const status = READING_STATUS[item.status]
        return (
          <button
            key={item.id}
            type="button"
            className={styles.row}
            data-unread={waiting ? 'true' : undefined}
            aria-current={item.id === selectedId ? 'true' : undefined}
            onClick={() => onSelect(item.id)}
          >
            <span className={styles.avatar} data-tone={status?.tone}>
              {name.charAt(0).toUpperCase()}
            </span>
            <span className={styles.rowMain}>
              <span className={styles.rowTop}>
                <span className={styles.person}>{name}</span>
                <span className={styles.time} data-wait={waiting ? 'true' : undefined}>
                  {waitingLabel(item.last_message_at, now)}
                </span>
              </span>
              <span className={styles.preview}>{previewText(item, 'expert') || item.question || 'Без вопроса, только тема'}</span>
              <span className={styles.rowSub}>
                <span>
                  {item.format === 'consultation' && <b className={styles.formatTag}>Консультация</b>}
                  {item.topic_titles.length > 0 ? item.topic_titles.join(', ') : item.topic_title}
                </span>
                <span className={styles.dot} data-tone={status?.tone}>
                  {status?.label ?? item.status}
                </span>
              </span>
            </span>
          </button>
        )
      })}
    </nav>
  )
}
